import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { useDatasourceAnalyticsEvents } from '../../../../analytics';
import { cancelButtonMessages } from './messages';
export var CancelButton = function CancelButton(_ref) {
  var getAnalyticsPayload = _ref.getAnalyticsPayload,
    onCancel = _ref.onCancel,
    testId = _ref.testId;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  var onCancelClick = useCallback(function () {
    fireEvent('ui.button.clicked.cancel', getAnalyticsPayload());
    onCancel();
  }, [getAnalyticsPayload, fireEvent, onCancel]);
  return /*#__PURE__*/React.createElement(Button, {
    appearance: "default",
    onClick: onCancelClick,
    testId: testId
  }, /*#__PURE__*/React.createElement(FormattedMessage, cancelButtonMessages.cancelButtonText));
};